<template>
    <div>
        <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="10">
                            <v-card-text>
                                <v-card-title class="titulopagina">Recepción de Despacho de Planta</v-card-title>
                            </v-card-text>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-card elevation="15"  width="100%" class="mb-6">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <h3 class="cyan lighten-3 mt-2">INFORMACIÓN DEL DESPACHO :</h3>
                                    </v-col>
                                    <v-col cols="3">
                                        <h4 class="cyan lighten-5 mt-2">Fecha : {{ despacho.fecha | fechaCompleta }} </h4>
                                    </v-col>
                                    <v-col cols="5">
                                        <h4 class="cyan lighten-5 mt-2">Bodega Destino : {{ despacho.bodegas.nombre || '' }} </h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="2">
                                        Patente: {{despacho.patente}}
                                    </v-col>
                                    <v-col cols="2">
                                        Kilos Despacho: {{despacho.kilos}}
                                    </v-col>
                                    <v-col cols="2">
                                        Kilos Romana: {{despacho.kilos_romana}}
                                    </v-col>
                                    <v-col cols="2">
                                        Nro. Guía: {{despacho.guia}}
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-row>

                    <v-row>
                        <v-col cols="2">
                            <v-text-field label="Folio Abastecimiento" v-model="folio_abastecimiento"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <label>Fecha Recepción</label>
                            <date-picker v-model="fecha_abastecimiento" placeholder ="Fecha Abastecimiento" format="DD-MM-YYYY" :default-value="fecha_abastecimiento" valueType="YYYY-MM-DD" class="mr-1"></date-picker>
                        </v-col>
                        <v-col cols="5">
                            <v-text-field label="Observaciones" v-model="observaciones"></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-card-title>
                                <v-btn dark small color="green darken-1" class="" @click="recepcionarDespacho"><v-icon>save</v-icon> Guardar</v-btn>
                            </v-card-title>
                        </v-col>
                        <v-col cols="2">
                            <v-card-title class="float-right">
                                <v-btn dark small color="orange darken-1" @click="volver"><v-icon>arrow_back</v-icon> Volver</v-btn>
                            </v-card-title>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="cabecera">LOTE</th>
                                <th class="cabecera">JUMBO</th>
                                <th class="cabecera">FECHA ELABORACIÓN</th>
                                <th class="cabecera">RECEPCIONADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in jumbos" :key="item.id">
                                <td class="text-center">{{item.lote.nombre_lote}}</td>
                                <td class="text-center">{{item.nro_jumbo}}</td>
                                <td class="text-center">{{item.resultado_analisis.fecha | formatearFecha}}</td>
                                <td class="text-center">
                                    <v-checkbox
                                        hide-details
                                        class="text-center mt-0"
                                        disabled
                                        v-model="item.check"
                                        :label="``"
                                    ></v-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
        </v-card>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapMutations, mapState } from "vuex";
export default {
    data: ()=>({
        id:null,
        despacho:{fecha:null,bodegas:{nombre:''}},
        jumbos:[],
        fecha_abastecimiento:new Date().toISOString().substr(0, 10),
        folio_abastecimiento:null,
        observaciones:'',
        movimiento:null,
        check:true
    }),
    mounted(){
        this.id = this.$route.params.id;
        //this.fecha_abastecimiento = new Date();
        this.cargar_despacho();
    },
    methods:{

        async cargar_despacho(){
            this.mostrarLoading({titulo:'Cargando Despacho ... ',color:'green'})
            await this.axios.get(`${this.base_url}despacho_harina/${this.id}`,this.headers).then((res)=>{
                console.log(res.data);
                this.despacho = res.data.despacho;
                this.jumbos = res.data.jumbos;
                this.jumbos.forEach((element,idx) => {
                    this.$set(this.jumbos[idx],'check',true);
                });
                this.cargar_movimiento();
            }).catch((e)=>{
                this.errorMessage(e, "Error al Cargar Despacho ");
            });
            this.ocultarLoading();
        },

        async cargar_movimiento(){
            if (this.despacho && this.despacho.id) {
                this.mostrarLoading({titulo:'Cargando Movimiento ... ',color:'green'})
                await this.axios.get(`${this.base_url}movimientos/despacho_pts_id/${this.despacho.id}`,this.headers).then((res)=>{
                    console.log('movimiento',res.data.data);
                    this.movimiento = res.data.data ? res.data.data : null;
                    this.fecha_abastecimiento = res.data.data ? this.moment(res.data.data.fecha_abastecimiento).format('YYYY-MM-DD') : this.moment().format('YYYY-MM-DD')  ;
                    this.folio_abastecimiento = res.data.data ? res.data.data.folio_abastecimiento : null;
                    this.observaciones = res.data.data ? res.data.data.observaciones : null;
                }).catch((e)=>{
                    this.errorMessage(e, "Error al Cargar Movimiento ");
                });
                this.ocultarLoading();
            }
        },

        async recepcionarDespacho(){
            this.mostrarLoading({titulo:'Guardando Despacho ... ',color:'green'})
            //crea un registro en movimientos con el detalle de jumbos (mov_detalles)
            let body = {
                id: this.movimiento ? this.movimiento.id : null,
                despacho_pts_id: this.id,
                tipo:'I', //ingreso
                motivo:1, //traslado
                bodega_origen:1, //bodega de planta calbuco
                bodega_destino: this.despacho ? this.despacho.bodegas_destino_id : null,
                guia: this.despacho ? this.despacho.guia : null,
                fecha_abastecimiento:this.fecha_abastecimiento,
                folio_abastecimiento:this.folio_abastecimiento,
                observaciones:this.observaciones,
                jumbos:this.jumbitos
            }

            await this.axios.post(`${this.base_url}movimientos/recepcionar_despacho_planta`,body,this.headers).then((res)=>{
                console.log(`Movimiento Creado`,res.data);
                this.$router.push({name:'despachos_harina'});
            }).catch((err)=>{
                this.errorMessage(err, "- Error al Modificar Movimiento - ");
            }).error((e)=>{
                this.errorMessage((e.data || "ERROR"), (e.errorMessage || "Error al Modificar Movimiento."));
            });
            this.ocultarLoading();
        },

        volver(){
            this.$router.push({name:'despachos_harina'});
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{
        jumbitos(){
            let array = [];
            this.jumbos.forEach(jum => {
                if(jum.check){
                    array.push({
                        id:jum.id
                    });
                }
            });
            return array;
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker
    }
}
</script>